import React, { useState } from "react";
import { List, ListItem, Typography } from "@mui/material";
import Card from "components/Card/Card";
import ListWith2Items from "components/List/ListBodyWith2Items";

function UpgradeSummary() {
  const [tableData] = useState(TABLE_DATA);

  return (
    <Card style={{ paddingBottom: 12 }}>
      <List>
        <ListItem
          sx={{ justifyContent: "space-between", padding: "0 0 16px 0" }}>
          <Typography variant="h2">Upgrades Summary</Typography>
        </ListItem>

        <ListWith2Items tableData={tableData} />
      </List>
    </Card>
  );
}

export default UpgradeSummary;

const TABLE_DATA = [
  {
    id: 0,
    key: "Total Upgrades",
    field: "37"
  },
  {
    id: 1,
    key: "Total Member Guests",
    field: "3616"
  },
  {
    id: 2,
    key: "Upgrade Rate",
    field: "1.0%"
  }
];
